"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingElements = void 0;
var React = require("react");
var LogoutComponentState_1 = require("./LogoutComponentState");
/** Stylesheets */
require("./LogoutComponent.scss");
var CommonSpinner_1 = require("../common/CommonSpinner");
var CommonFunctions_1 = require("../common/CommonFunctions/CommonFunctions");
var LoginConfiguration_1 = require("../../services/LoginConfiguration");
var LoginApi_1 = require("../../api/LoginApi");
var FeatureToggleService_1 = require("../../services/FeatureToggleService");
/** Api, Reporting, Mappers, Request, Response */
var LoadingElements;
(function (LoadingElements) {
    LoadingElements[LoadingElements["MSE"] = 0] = "MSE";
    LoadingElements[LoadingElements["IDP"] = 1] = "IDP";
    LoadingElements[LoadingElements["MS"] = 2] = "MS";
    LoadingElements[LoadingElements["BEST_WWW"] = 3] = "BEST_WWW";
    LoadingElements[LoadingElements["BEST_M"] = 4] = "BEST_M";
})(LoadingElements = exports.LoadingElements || (exports.LoadingElements = {}));
var FEATURE_TOGGLE_LOGIN_KMSI_ENABLED = 'svc-idm-login-kmsi-enabled';
var LogoutComponent = /** @class */ (function (_super) {
    __extends(LogoutComponent, _super);
    function LogoutComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.checkKmsiFlag = false;
        _this.commonFunctions = CommonFunctions_1.CommonFunctions.getInstance();
        _this.api = new LoginApi_1.default();
        _this.loaded = new Map();
        // bestSessionInvalidateList: BestUrlConfig[] = [];
        _this.bestSessionInvalidate = [];
        _this.state = new LogoutComponentState_1.default();
        _this.idpIframeDone = _this.idpIframeDone.bind(_this);
        _this.mseIframeDone = _this.mseIframeDone.bind(_this);
        // Initializing this map
        for (var item in LoadingElements) {
            if (!isNaN(Number(item))) {
                _this.loaded.set(+item, false);
            }
        }
        _this.idpInvalidateSession();
        _this.setupBestSessionInvalidateList();
        return _this;
    }
    LogoutComponent.prototype.componentDidMount = function () {
        var _this = this;
        // We only want to wait so long.
        setTimeout(function () {
            console.warn('login-ui :: timeout occured waiting for sub-components.  triggering logout');
            _this.logout();
        }, LoginConfiguration_1.default.logoutLoadTimeout);
    };
    LogoutComponent.prototype.setupBestSessionInvalidateList = function () {
        var bestSessionInvalidateList = [];
        if (window.location.hostname === 'www.att.com') {
            bestSessionInvalidateList.push(this.createBestInvalidateEntry('https://www.att.com', LoadingElements.BEST_WWW));
            bestSessionInvalidateList.push(this.createBestInvalidateEntry('https://m.att.com', LoadingElements.BEST_M));
        }
        else {
            bestSessionInvalidateList.push(this.createBestInvalidateEntry(this.getMseBaseUrl(), LoadingElements.BEST_WWW));
            // For this usecase, we aren't calling m.dot env so don't need to wait for it
            this.loaded.set(LoadingElements.BEST_M, true);
        }
        this.bestSessionInvalidate = bestSessionInvalidateList.map(function (entry) {
            return React.createElement("img", { key: entry.url, src: entry.url, onLoad: entry.callback, onError: entry.callback });
        });
    };
    LogoutComponent.prototype.createBestInvalidateEntry = function (host, flag) {
        var _this = this;
        return {
            url: host + "/myatt/lgn/resources/unauth/login/haloc/clear-session",
            callback: function () {
                console.log("login-ui: best done fired: ", host);
                _this.externalLoadComplete(flag);
            },
        };
    };
    LogoutComponent.prototype.idpInvalidateSession = function () {
        var _this = this;
        // Trigger login in MS to clear cookies and jwt
        this.api.invalidateSession(true).then(function () {
            _this.externalLoadComplete(LoadingElements.MS);
        }).catch(function () {
            console.warn('login-ui :: error with invalidate session');
            _this.externalLoadComplete(LoadingElements.MS);
        });
    };
    LogoutComponent.prototype.getMseBaseUrl = function () {
        var baseUrl = '';
        try {
            // If we have a Referer url - then use that as
            // Otherwise use the current domain to find if test
            // then then use that to go to corresponding mse
            if (this.commonFunctions.notBlankCheck(this.props.data.myattServicesRefererUrl)) {
                var urlparts = this.props.data.myattServicesRefererUrl.split('/');
                baseUrl = "https://" + urlparts[2];
            }
            else if (!this.props.data.myattServiceConfiguration) {
                console.error('login-ui:: No configuration provided, using prod');
                baseUrl = 'https://www.att.com';
            }
            else if (this.commonFunctions.isTestEnv()) {
                baseUrl = this.props.data.myattServiceConfiguration.fullWebServerUrl;
            }
            else {
                baseUrl = this.props.data.myattServiceConfiguration.fullWebServerUrlProd;
            }
        }
        catch (e) {
            console.error('login-ui: Error encounted processing determining base url, using prod::', e);
            baseUrl = 'https://www.att.com';
        }
        return baseUrl;
    };
    // Running this last just before redirect
    // Most of this is handled in the ise iframe
    // but this is to be srue
    LogoutComponent.prototype.clearSessionStorage = function () {
        try {
            sessionStorage.removeItem('halo.token.validated.for');
            sessionStorage.removeItem('halocIsPassiveRedirection');
            sessionStorage.removeItem('halocLoginRedirectionDone');
            sessionStorage.removeItem('appshell.halo.redirect.flag.halocIsPassiveRedirection');
            sessionStorage.removeItem('appshell.halo.redirect.flag.halocLoginRedirectionDone');
            sessionStorage.removeItem('halo.reg.forgot.actionType');
            sessionStorage.removeItem('MYATTSESSION:common'); // IDP SESSION CLEARANCE
            sessionStorage.removeItem('myattHandoffObj');
            sessionStorage.removeItem('ISE_APP_SHELL:globalNavUpdate');
            sessionStorage.removeItem('ISE_MYSERVICES:globalNavUpdate');
            sessionStorage.removeItem('ISE_ACC_SERVICES:globalNavUpdate');
            sessionStorage.removeItem('ISE_PROFILE:globalNavUpdate');
            sessionStorage.removeItem('ISE_PROFILE:UserProfileResponse');
            sessionStorage.removeItem('Dtvn_Payment:globalNavUpdate');
            sessionStorage.removeItem('ISE_OVERVIEW:globalNavUpdate');
            sessionStorage.removeItem('ISE_OVERVIEW:loadMyServicesConsole');
            sessionStorage.removeItem('IDM_PROFILE:NotificationPreferences');
            sessionStorage.removeItem('IDM_PROFILE:UserResponse');
            sessionStorage.removeItem('IDM_PROFILE:IdmResponse');
            sessionStorage.removeItem('IDM_PROFILE:NotificationResponse');
            sessionStorage.removeItem('IDM_PROFILE:PaymentResponse');
            sessionStorage.removeItem('IDM_PROFILE:WirelessDetailsResponse');
            sessionStorage.removeItem('IDM_PROFILE:AccountSubscriberInfoResponse');
            sessionStorage.removeItem('externalscripts');
            sessionStorage.removeItem('iseGlobalNav');
            sessionStorage.removeItem('snapshot');
            sessionStorage.removeItem('wlsPostpaid');
            sessionStorage.removeItem('wlsPostpaidUpsell');
            localStorage.removeItem('fnIntend');
        }
        catch (e) {
            console.error('Error occured clearing sessionStorage', e);
        }
    };
    // Tracks when each of the indivitual loads
    // are complete and triggers final redirect when
    // done
    LogoutComponent.prototype.externalLoadComplete = function (which) {
        // Set that frame loaded
        this.loaded.set(which, true);
        // Check if all have loaded
        var done = true;
        this.loaded.forEach(function (v) {
            if (!v) {
                done = false;
            }
        });
        if (done) {
            this.delayThenLogout();
        }
    };
    LogoutComponent.prototype.idpIframeDone = function () {
        console.log('login-ui : idpIFrameDone fired');
        this.externalLoadComplete(LoadingElements.IDP);
    };
    LogoutComponent.prototype.mseIframeDone = function () {
        console.log('login-ui : mseIframeDone fired');
        this.externalLoadComplete(LoadingElements.MSE);
    };
    // All iframes / backends are done
    // Wait a small bit of time then redirect.
    // The wait is to allow any iframe js to run.
    LogoutComponent.prototype.delayThenLogout = function () {
        var _this = this;
        setTimeout(function () {
            _this.logout();
        }, LoginConfiguration_1.default.logoutRedirectDelay);
    };
    LogoutComponent.prototype.logout = function () {
        return __awaiter(this, void 0, void 0, function () {
            var haloLogout, destinationUrl, port, host, loginUrl;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('login-ui : all complete logout triggered');
                        this.clearSessionStorage();
                        haloLogout = this.commonFunctions.isTestEnv() ? // existing
                            LoginConfiguration_1.default.haloCEndpointLogoutTestUrl :
                            LoginConfiguration_1.default.haloCEndpointLogoutProdUrl;
                        // KMSI
                        return [4 /*yield*/, this.getKMSIFeatureFlagDetails()];
                    case 1:
                        // KMSI
                        _a.sent();
                        if (this.checkKmsiFlag) {
                            haloLogout = this.commonFunctions.isTestEnv() ?
                                LoginConfiguration_1.default.haloCEndpointLogoutKMSITestUrl :
                                LoginConfiguration_1.default.haloCEndpointLogoutKMSIProdUrl;
                        }
                        destinationUrl = '';
                        if (!!(window.location.search
                            && window.location.search.indexOf('target_url=') !== -1)) {
                            destinationUrl = this.commonFunctions.getTargetUrl();
                        }
                        // If destination=login is passed, we go back to /acctmgmt/login
                        if (this.commonFunctions.blankCheck(destinationUrl) &&
                            !!(window.location.search
                                && window.location.search.indexOf('destination=login') !== -1)) {
                            port = window.location.port ? ':' + window.location.port : '';
                            host = window.location.hostname + port;
                            loginUrl = window.location.protocol + '//' + host + '/acctmgmt/login';
                            destinationUrl = loginUrl;
                        }
                        if (this.commonFunctions.blankCheck(destinationUrl)) {
                            destinationUrl = 'https://www.att.com/';
                        }
                        console.log(haloLogout + encodeURIComponent(destinationUrl));
                        window.location.href = haloLogout + encodeURIComponent(destinationUrl);
                        return [2 /*return*/];
                }
            });
        });
    };
    LogoutComponent.prototype.getKMSIFeatureFlagDetails = function () {
        return __awaiter(this, void 0, void 0, function () {
            var featureKmsiToggle, kmsiParam;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, FeatureToggleService_1.default.checkFeatureToggleEnabled(FEATURE_TOGGLE_LOGIN_KMSI_ENABLED)];
                    case 1:
                        featureKmsiToggle = _a.sent();
                        console.log(featureKmsiToggle);
                        if (featureKmsiToggle) {
                            kmsiParam = this.commonFunctions.getQueryParam('kmsi');
                            console.log('login-ui::logout- FEATURE_TOGGLE_LOGIN_KMSI_ENABLED');
                            if (this.commonFunctions.blankCheck(kmsiParam)) {
                                console.log('login-ui::logout- kmsi=true param');
                                this.checkKmsiFlag = true;
                            }
                            else if (this.commonFunctions.notBlankCheck(kmsiParam) &&
                                (kmsiParam === 'Y' || kmsiParam === 'y' || kmsiParam === 'true')) {
                                console.log('login-ui::logout- kmsi=true param');
                                this.checkKmsiFlag = true;
                            }
                            else if (this.commonFunctions.notBlankCheck(kmsiParam) &&
                                (kmsiParam === 'N' || kmsiParam === 'n' || kmsiParam === 'false')) {
                                this.checkKmsiFlag = false;
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    LogoutComponent.prototype.render = function () {
        var styleDisplayNone = {
            display: 'none',
        };
        return (React.createElement("div", null,
            React.createElement(CommonSpinner_1.default, null),
            React.createElement("iframe", { src: "/acctmgmt/assets/emptyISESession.html", style: styleDisplayNone, onLoad: this.idpIframeDone, onError: this.idpIframeDone }),
            React.createElement("iframe", { src: this.getMseBaseUrl() + '/ui/services_co_myatt_login/1.0.0/partials/idplogout.html', style: styleDisplayNone, onLoad: this.mseIframeDone, onError: this.mseIframeDone }),
            this.bestSessionInvalidate));
    };
    return LogoutComponent;
}(React.Component));
exports.default = LogoutComponent;
//# sourceMappingURL=LogoutComponent.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/LogoutComponent/LogoutComponent.js
// module id = 1695
// module chunks = 8